import FormattedMessage from 'I18n/components/FormattedMessage';
import { DataSyncIcon, DataSyncLeftIcon, DataSyncRightIcon, DownIcon, RightIcon, SprocketIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { Image } from 'foundations-components/transitional/components/Image';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Fragment, useMemo, useState } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SharedDataTableRow({
  groupedDataSync,
  index
}) {
  const {
    iconUrl
  } = useDetailsPageContext();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const {
    sync,
    target,
    description,
    fieldMappings,
    dataArray
  } = groupedDataSync;
  const renderedSyncIcon = useMemo(() => {
    if (sync === 'INBOUND') {
      return DataSyncRightIcon;
    } else if (sync === 'OUTBOUND') {
      return DataSyncLeftIcon;
    } else {
      return DataSyncIcon;
    }
  }, [sync]);
  const renderedCaretIcon = useMemo(() => {
    return dropdownOpen ? DownIcon : RightIcon;
  }, [dropdownOpen]);
  const renderedFieldMappings = useMemo(() => {
    return ['DEFAULT', 'CUSTOM'].map(fieldType => {
      const mappings = fieldMappings.filter(mapping => mapping.fieldType === fieldType);
      const isDefaultMapping = fieldType === 'DEFAULT';
      if (!mappings.length) {
        return null;
      }
      return /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("tr", {
          "data-test-id": "field-mapping-dropdown",
          children: /*#__PURE__*/_jsx("td", {
            colSpan: 3,
            children: /*#__PURE__*/_jsx(Text, {
              typography: "body-125",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `marketplace-ui-apps-core.dataSyncs.fieldMappings.${fieldType}`
              })
            })
          })
        }), mappings.map((mapping, mappingIndex) => {
          return /*#__PURE__*/_jsxs("tr", {
            "data-test-id": "field-mapping",
            children: [/*#__PURE__*/_jsx("td", {
              colSpan: isDefaultMapping ? 1 : 3,
              children: /*#__PURE__*/_jsx(Text, {
                as: "small",
                children: mapping.appField
              })
            }), isDefaultMapping && /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx("td", {}), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Flex, {
                  paddingInlineStart: "1500",
                  children: /*#__PURE__*/_jsx(Text, {
                    as: "small",
                    children: mapping.hubSpotField
                  })
                })
              })]
            })]
          }, `default-mapping-${mappingIndex}`);
        })]
      }, fieldType);
    });
  }, [fieldMappings]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("tr", {
      onClick: () => setDropdownOpen(!dropdownOpen),
      children: [/*#__PURE__*/_jsx("td", {
        width: "35%",
        style: {
          paddingLeft: fieldMappings.length ? '4px' : '24px'
        },
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          children: [fieldMappings.length ? /*#__PURE__*/_jsx(IconHolder, {
            color: "do-not-use-calypso",
            icon: renderedCaretIcon,
            size: "300",
            padding: "0"
          }) : null, iconUrl && /*#__PURE__*/_jsx(Image, {
            inlineSize: "20px",
            src: iconUrl,
            marginInlineEnd: "200"
          }), /*#__PURE__*/_jsx(Text, {
            typography: "heading-50",
            textTransform: "none",
            children: target
          })]
        })
      }), /*#__PURE__*/_jsx("td", {
        width: "25%",
        children: /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          justifyContent: "center",
          children: /*#__PURE__*/_jsx(Tooltip, {
            placement: "top",
            title: description || /*#__PURE__*/_jsx(FormattedMessage, {
              message: `marketplace-ui-apps-core.dataSyncs.sync.${sync}`
            }),
            children: /*#__PURE__*/_jsx(IconHolder, {
              color: "fill-primary-default",
              icon: renderedSyncIcon,
              size: "800",
              padding: "0"
            })
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        width: "40%",
        children: /*#__PURE__*/_jsx(Flex, {
          flexDirection: "column",
          gap: "200",
          paddingInlineStart: "1500",
          children: dataArray.map((data, dataIndex) => {
            return /*#__PURE__*/_jsxs(Flex, {
              alignItems: "center",
              gap: "200",
              children: [/*#__PURE__*/_jsx(SprocketIcon, {
                color: "do-not-use-lorax",
                size: "400"
              }), /*#__PURE__*/_jsx(Text, {
                typography: "heading-50",
                textTransform: "none",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `marketplace-ui-apps-core.dataSyncs.data.${data}`
                })
              })]
            }, dataIndex);
          })
        })
      })]
    }, index), dropdownOpen && renderedFieldMappings]
  });
}